import { db } from './firebase';
import { collection, addDoc, getDocs, query, orderBy, doc, updateDoc, deleteDoc } from 'firebase/firestore';
import { WarmupArticle } from '../models/WarmupArticle';

const COLLECTION = 'warmup_articles';

export async function addWarmupArticle(article: WarmupArticle) {
  const docRef = await addDoc(collection(db, COLLECTION), {
    ...article,
    visible: article.visible !== undefined ? article.visible : true, // Por defecto visible
    createdAt: Date.now(),
  });
  return docRef.id;
}

export async function getWarmupArticles(): Promise<WarmupArticle[]> {
  const q = query(collection(db, COLLECTION), orderBy('createdAt', 'desc'));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => {
    const data = doc.data();
    return { 
      id: doc.id, 
      ...data,
      visible: data.visible !== undefined ? data.visible : true // Por defecto visible para artículos existentes
    } as WarmupArticle;
  });
}

export async function updateWarmupArticleVisibility(articleId: string, visible: boolean): Promise<void> {
  const docRef = doc(db, COLLECTION, articleId);
  await updateDoc(docRef, { visible });
}

export async function deleteWarmupArticle(articleId: string): Promise<void> {
  const docRef = doc(db, COLLECTION, articleId);
  await deleteDoc(docRef);
}
